import React from "react";
import WaveText from "../WaveText";

export default function LeadInActivitiesGeneratorPanel({
  showLeadInActivitiesGenerator, generatedLeadInActivities, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showFourOpinionsGenerator, showCommunicativeSituationsGenerator, showGrammarRulesGenerator,
  leadInActivitiesInput, setLeadInActivitiesInput, leadInActivitiesLevel, setLeadInActivitiesLevel,
  leadInActivitiesLoading, handleScrollInDropdown,
  handleLeadInActivitiesGenerate, handleLeadInActivitiesInsert, handleLeadInActivitiesCancel,
}) {
  if (!((showLeadInActivitiesGenerator || generatedLeadInActivities) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform: 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleLeadInActivitiesCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Lead-in Activities</span>
      </div>

      <textarea
        value={leadInActivitiesInput}
        onChange={e => setLeadInActivitiesInput(e.target.value)}
        placeholder="Enter your lesson text or topic here..."
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          CEFR Level:
          <select
            value={leadInActivitiesLevel}
            onChange={e => setLeadInActivitiesLevel(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>
      </div>

      <button
        onClick={handleLeadInActivitiesGenerate}
        disabled={leadInActivitiesLoading || !leadInActivitiesInput.trim()}
        className={leadInActivitiesLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: leadInActivitiesLoading || !leadInActivitiesInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: leadInActivitiesLoading || !leadInActivitiesInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: leadInActivitiesLoading || !leadInActivitiesInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {leadInActivitiesLoading ? <WaveText /> : 'Do the magic!'}
      </button>

      {generatedLeadInActivities && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Lead-in Activities
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            Level: {leadInActivitiesLevel} • {generatedLeadInActivities.activities.length} activities ready
          </div>

          <div style={{
            maxHeight: '200px',
            overflowY: 'auto',
            marginBottom: 12,
            padding: '8px',
            background: '#fff',
            borderRadius: '6px',
            border: '1px solid #e0e0e0'
          }}
          onWheel={handleScrollInDropdown}>
            {generatedLeadInActivities.activities.map((activity, index) => (
              <div key={index} style={{
                padding: '8px 0',
                borderBottom: index < generatedLeadInActivities.activities.length - 1 ? '1px solid #f0f0f0' : 'none',
                fontSize: '13px'
              }}>
                <div style={{ fontWeight: 600, color: '#22223b', marginBottom: '2px' }}>
                  {activity.title}
                  <span style={{
                    fontSize: '11px',
                    color: '#8a2be2',
                    fontWeight: 500,
                    marginLeft: '8px',
                    textTransform: 'capitalize'
                  }}>
                    ({activity.type})
                  </span>
                </div>
                <div style={{ color: '#6c757d', fontSize: '12px' }}>
                  {activity.description}
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleLeadInActivitiesInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
